import styles from './DeckPreview.module.css';
import { SuitIcon } from './SuitIcon.js';

/**
 * A deck at a glance for the owner's pickers: a back beside three faces, one
 * of each other suit, so a four-colour deck shows its colours. It reads the
 * `--card-*` variables from whatever the swatch around it sets.
 */
export function DeckPreview() {
  return (
    <span className={styles.preview} aria-hidden="true">
      <span className={`${styles.mini} ${styles.back}`} />
      <span className={styles.mini} data-suit="S">
        A
        <SuitIcon suit="S" />
      </span>
      <span className={styles.mini} data-suit="D">
        K
        <SuitIcon suit="D" />
      </span>
      <span className={styles.mini} data-suit="C">
        Q
        <SuitIcon suit="C" />
      </span>
    </span>
  );
}
